import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Container from '../components/container'
import SearchBar from '../components/search-bar'
import RelatedPages from '../components/related-pages'
import BlogPostPreviewList from '../components/blog-post-preview-list'
import DynamicZoneComponent from '../components/dynamic-zone-component'
import Markdown from "react-markdown"
import ArticleHeader from "../components/article-header"
import ArticleWrapper from "../components/article-wrapper"
import ArticleFooter from "../components/article-footer"
import OfferAffiliateNotice from "../components/offer-affiliatenotice"
import HeroAdSpace from "../components/hero-ad-space"
import HeroMiniAdSpace from "../components/hero-mini-ad-space"

import * as styles from './blog-post.module.css'


function string_to_slug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
  
    // remove accents, swap ñ for n, etc
    var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaaeeeeiiiioooouuuunc------";

    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}


function BlogPost ({article, metadata, search_index}) {

  var is_affiliate = []
  // loop through data and determine if there are affiliate offers
  // check list for offers
  if(article.body){
      for(let i = 0; i < article.body.length; i++){
          if (article.body[i].offers){
              for(let j = 0; j < article.body[i].offers.length; j++){
                is_affiliate.push(true)
              }
          }
      }
  }

  // devine section numbers if more than one
  var sectionNumber = 0

  return (
    <>
        <ArticleHeader article={article} metadata={metadata}></ArticleHeader>
        <HeroAdSpace></HeroAdSpace>
        <HeroMiniAdSpace></HeroMiniAdSpace>
            <ArticleWrapper article={article}>
                <div><Container>
                    <Markdown children={article.body_introduction} skipHtml={true} />

                    {
                        // display body components table of contents
                        article.body && article.body.length > 1 &&
                            <>
                                <ol>
                                { article.body.map(component => component && (
                                    // if there is a title, then add it to table of contents
                                    <>
                                        { component.title &&
                                            <li key={"shortcut_"+component._id}>
                                                <a href={"#"+string_to_slug(component.title)}>{component.title}</a>
                                            </li>
                                        }
                                    </>
                                ))
                                }
                                </ol>
                            </>
                    }
                    
                    { article.body_introduction && 
                        <div dangerouslySetInnerHTML={{ __html: `
                            <!-- Ezoic - after_introduction - under_first_paragraph -->
                            <div id="ezoic-pub-ad-placeholder-102"> </div>
                            <!-- End Ezoic - after_introduction - under_first_paragraph -->`}}/>
                    }

                    {
                    // add children posts if any
                    article.children && article.children.length > 0 && (
                        <BlogPostPreviewList
                            nodes={article.children}
                            max_n="5"
                            page_type={article.page_type}
                        />
                    )}

                    {
                        // show affiliate notice
                        is_affiliate && is_affiliate.length > 0 &&
                        <OfferAffiliateNotice></OfferAffiliateNotice>
                    }
                </Container></div>

                    {
                        // display body components
                        article.body && article.body.map(component => {
                            // increment
                            //{ component.title ? anchor = string_to_slug(component.title) : anchor="" }
                            var anchor = ""
                            var indexText = ""
                            if (component.title){
                                anchor = string_to_slug( component.title )
                                sectionNumber = sectionNumber + 1
                                indexText = sectionNumber+". "
                            }
                            return (component && 
                                <>
                                    <DynamicZoneComponent component={component} index={indexText} anchor={anchor}></DynamicZoneComponent>
                                </>
                            )
                        }
                        )
                    }
                    <Markdown children={article.body_conclution} skipHtml={true} />
            </ArticleWrapper>
            <div dangerouslySetInnerHTML={{ __html: `
                <!-- Ezoic - bottom_of_page - bottom_of_page -->
                <div id="ezoic-pub-ad-placeholder-106"> </div>
                <!-- End Ezoic - bottom_of_page - bottom_of_page -->`}}/>
            
            <Container>
              <ArticleFooter ></ArticleFooter>
              {search_index &&
                <SearchBar></SearchBar>
              }
            </Container>
            

        <Container>
            {
                // related pages
                article.related_pages && article.related_pages.length > 0 && (
                <RelatedPages nodes={article.related_pages}></RelatedPages>
            )}
        </Container>
    </>
  )
}

export default BlogPost
